import React, { useMemo } from 'react';
import { Field, Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import PropTypes from 'prop-types';

import { useAutoSaveDraft } from '../../commons/draftHooks';
import { PageErrorComponent } from '../../commons/PageErrorComponent';
import Disclaimer from '../../commons/Disclaimer';
import GenericCheckboxInputField from '../../commons/form-fields/GenericCheckboxInputField';
import { getPrivacyPolicyByCountry } from '../../commons/privacy-policy/PrivacyPolicyUtils';

const PrivacyPolicyFields = (props) => {
    const privacyPolicy = getPrivacyPolicyByCountry(props.country);
    return (
        <div className="mt-2 max-w-6xl w-full mx-auto py-4">
            <Disclaimer>
                <p>Privacy Notice for Industry Consultants</p>
            </Disclaimer>
            <div
                className={
                    'w-full mt-4 overflow-hidden max-w-4xl mx-auto bg-white px-6 py-4 md:mt-6 md:mb-6 rounded shadow-md text-sm'
                }
            >
                {privacyPolicy.element}
            </div>
            <Field
                name={'application.privacyPolicy.version'}
                initialValue={privacyPolicy.version} // TODO - allow version control from backend/file
                render={() => <div />}
            />
            <Field
                name={'application.privacyPolicy.country'}
                initialValue={props.country} // TODO - allow version control from backend/file
                render={() => <div />}
            />
            <GenericCheckboxInputField
                name="application.privacyPolicy.privacyPolicyAccepted"
                label={'I hereby acknowledge and accept the privacy notice'}
                errorMsg={
                    'Please confirm that you have read the privacy notice'
                }
                required
            />
        </div>
    );
};

PrivacyPolicyFields.propTypes = {
    country: PropTypes.string,
};

const PrivacyPolicyOnboardingPage = (props) => {
    // return same decorator for subsequent renders.
    const focusOnError = useMemo(() => createDecorator(), []);
    return (
        <Form
            onSubmit={(values) => {
                props.nextFn(values);
            }}
            decorators={[focusOnError]}
            initialValues={props.initialValues}
            keepDirtyOnReinitialize
            render={({
                values,
                errors,
                handleSubmit,
                submitFailed,
                submitErrors,
            }) => {
                useAutoSaveDraft(props.autoSaveCallback, values, errors);

                return (
                    <form onSubmit={handleSubmit}>
                        <PrivacyPolicyFields country={props.country} />

                        {!submitErrors && submitFailed && errors && (
                            <PageErrorComponent error={errors} />
                        )}
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                            type="button"
                            onClick={() => props.prevFn(values, errors)}
                            data-testid="previous-page"
                        >
                            &#60; Previous Page
                        </button>
                        <button
                            className="disabled:opacity-50 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded float-right"
                            type="submit"
                            data-testid="next-page"
                            // disabled
                        >
                            Next Page &#62;
                        </button>
                    </form>
                );
            }}
        />
    );
};

PrivacyPolicyOnboardingPage.propTypes = {
    initialValues: PropTypes.any,
    country: PropTypes.string,
    autoSaveCallback: PropTypes.func,
    nextFn: PropTypes.func,
    prevFn: PropTypes.func,
};

export { PrivacyPolicyOnboardingPage };
